export default __webpack_public_path__ + "static/p1-4088143a4b605b2812b3146d49a449a9.png";